import { useEffect, useState } from 'react';
import { Handshake } from 'lucide-react';

export const TeamSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const element = document.getElementById('team-section');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="team-section" className="py-20 bg-sand">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-slate mb-6">
            Who We Are
          </h2>
          <p className="font-inter text-lg text-slate/80 max-w-3xl mx-auto leading-relaxed">
            A small, dedicated team of camp directors, kitchen staff, and engineers passionate about 
            making food operations efficient and joyful.
          </p>
        </div>

        {/* Team Card */}
        <div
          className={`max-w-md mx-auto mb-12 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-deep-teal/20 hover:shadow-xl transition-shadow duration-300">
            {/* Avatar */}
            <div className="flex items-center justify-center w-24 h-24 mx-auto mb-6 rounded-full bg-gradient-to-br from-deep-teal to-copper text-ivory text-3xl font-playfair font-bold">
              MB
            </div>
            
            {/* Info */}
            <div className="text-center">
              <h3 className="font-playfair text-2xl font-semibold text-slate mb-2">
                Mark Beyer
              </h3>
              <p className="font-inter text-copper font-medium mb-2">
                CEO, CampChef Pro
              </p>
              <p className="font-inter text-slate/70">
                Product & Partnerships
              </p>
            </div>
          </div>
        </div>

        {/* Partner Note */}
        <div
          className={`max-w-2xl mx-auto transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="bg-gradient-to-r from-deep-teal/10 to-copper/10 rounded-xl p-8 border border-deep-teal/20">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-copper/20">
                  <Handshake className="w-6 h-6 text-copper" />
                </div>
              </div>
              <div>
                <p className="font-inter text-lg text-slate/90 leading-relaxed">
                  We work hand-in-hand with <span className="font-semibold text-copper">Sysco</span> and partner camps 
                  to continuously improve CampChef Pro.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
